import { render, staticRenderFns } from "./OnizleForm.vue?vue&type=template&id=f821e96a&scoped=true"
import script from "./OnizleForm.vue?vue&type=script&lang=ts"
export * from "./OnizleForm.vue?vue&type=script&lang=ts"
import style0 from "./OnizleForm.vue?vue&type=style&index=0&id=f821e96a&prod&scoped=true&lang=css"
import style1 from "./OnizleForm.vue?vue&type=style&index=1&id=f821e96a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f821e96a",
  null
  
)

export default component.exports